export interface BoardColors {
  light: string;
  dark: string;
  name: string;
}

// Predefined board themes
export const BOARD_THEMES: BoardColors[] = [
  { name: "Classic", light: "#f0d9b5", dark: "#b58863" },
  { name: "Green", light: "#eeeed2", dark: "#769656" },
  { name: "Blue", light: "#dee3e6", dark: "#8ca2ad" },
  { name: "Brown", light: "#f0d9b5", dark: "#946f51" },
  { name: "Purple", light: "#e8e9db", dark: "#7d4a8d" },
  { name: "Pink", light: "#ffe0e0", dark: "#ff69b4" },
  { name: "Wood", light: "#deb887", dark: "#855e42" },
  { name: "Tournament", light: "#e9edcc", dark: "#779952" },
  { name: "Marble", light: "#eae9e9", dark: "#7b7b7b" },
  { name: "Bubblegum", light: "#ffcfdf", dark: "#ff69b4" },
  { name: "Emerald", light: "#e0f0e0", dark: "#2e8b57" },
  { name: "Coral", light: "#ffe4e1", dark: "#ff7f50" },
];

